<button
  class="{{ buttonClass }}"
  [type]="type"
  [ngClass]="{
    compact: compact,
    selected: selected,
    flexible: flexible
  }"
  [disabled]="disabled"
  (click)="!isProcessing && onClick.emit($event)"
>
  <ng-container *ngIf="!isProcessing">
    <i *ngIf="icon && !iconPosition" class="{{ icon }}"></i>
    <i *ngIf="icon && iconPosition === 'left'" class="{{ icon }} icon-left"></i>
    <span class="text">{{ text }}</span>
    <ng-content></ng-content>
    <i *ngIf="icon && iconPosition === 'right'" class="{{ icon }} icon-right"></i>
  </ng-container>
  <rx-applications-input-loading *ngIf="isProcessing" [invertColour]="buttonClass === 'primary'" [centered]="true">
  </rx-applications-input-loading>
</button>
